import { render, staticRenderFns, recyclableRender, components } from "./store-home.vue?vue&type=template&id=edb8ba0e&scoped=true&"
var renderjs
import script from "./store-home.vue?vue&type=script&lang=js&"
export * from "./store-home.vue?vue&type=script&lang=js&"
import style0 from "./store-home.vue?vue&type=style&index=0&id=edb8ba0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8ba0e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/store-home/store-home.vue"
export default component.exports